<template>
  <div class="multiselect-choices" role="group" :aria-label="label || undefined">
    <label v-for="choice in normalizedChoices" :key="choice" class="multiselect-choice">
      <input
        v-if="allowsMultiple"
        type="checkbox"
        :checked="isSelected(choice)"
        @change="onCheck(choice, $event.target.checked)"
      />
      <input
        v-else
        type="radio"
        :name="radioName"
        :checked="isSelected(choice)"
        @change="onSingle(choice)"
      />
      <span>{{ choice }}</span>
    </label>
  </div>
</template>

<script>
import { normalizeChoices, parseStoredSelection, selectionToStored } from '../lib/multiselect-cell.js'

export default {
  name: 'MultiselectChoices',
  props: {
    modelValue: {
      type: [String, Number, Array, Object],
      default: ''
    },
    choices: {
      type: Array,
      default: () => []
    },
    selectionMode: {
      type: String,
      default: 'multiple'
    },
    label: {
      type: String,
      default: ''
    },
    radioName: {
      type: String,
      default: 'multiselect'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    allowsMultiple () {
      return this.selectionMode !== 'single'
    },
    normalizedChoices () {
      return normalizeChoices(this.choices)
    },
    selected () {
      return parseStoredSelection(this.modelValue, this.choices)
    }
  },
  methods: {
    isSelected (choice) {
      return this.selected.includes(choice)
    },
    publish (next) {
      this.$emit('update:modelValue', selectionToStored(next, this.selectionMode, this.choices))
    },
    onCheck (choice, checked) {
      const next = this.selected.filter(value => value !== choice)
      if (checked) next.push(choice)
      this.publish(next)
    },
    onSingle (choice) {
      this.publish([choice])
    },
    focus () {
      const input = this.$el && this.$el.querySelector('input')
      if (input) input.focus()
    }
  }
}
</script>

<style scoped>
.multiselect-choices {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 220px;
  overflow: auto;
}
.multiselect-choice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-weight: normal;
  cursor: pointer;
}
.multiselect-choice input {
  accent-color: #9ad12b;
  width: 15px;
  height: 15px;
  margin: 0;
}
</style>
